// extracted by mini-css-extract-plugin
export default {"container":"HFviEz","buttons":"e3S63n","button":"V4CVht","active":"RhEmU3","slide":"Cgld9N","name":"r15pI7","quote":"B4Wu0m"};